<div [ngSwitch]="column.checked" class="column" [class.column-sm]="column.static">
  <div *ngSwitchCase="'yes'" class="text-success">Yes</div>
  <div *ngSwitchCase="'no'" class="sm-text-default-red">No</div>
  <div *ngSwitchCase="'na'" class="text-primary">N/A</div>
  <div *ngSwitchCase="" class="text-muted">-</div>
</div>
